import Vue from 'vue';
import VueRouter from 'vue-router';
const envJudge = require('../utils/envJudge');

Vue.use(VueRouter);

export const authRoute = [
  {
    path: '/',
    redirect: '/systemMsg'
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/login/login')
  // },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: () => import('@/views/noAuth')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/views/login/forgetPwd')
  }
];
const router = new VueRouter({
  base: envJudge(),
  routes: authRoute
});

export default router;
